<template>
  <div class="container">
    <r-process :dataArr="processData"></r-process>
    <el-card shadow="never" class="card">
      <span>Trans#:{{ $route.query.bpmId }}</span>
    </el-card>
    <el-card shadow="never" class="card" header="BASIC INFORMATION">
      <customize-form-info
        ref="userInfoForm"
        :infoData="_basicInfoData"
        :isExtra="true"
      >
        <template v-slot:cosnameSlot v-if="basicInfoData.length">
          <span class="customerId" @click="goSnapShot(companydata)">
            {{ companydata.name }}
          </span>
        </template>
      </customize-form-info>
    </el-card>
    <el-card class="card" shadow="never" header="JAPAN" v-if="isJapan">
      <customize-form-info
        ref="japanInfoForm"
        :infoData="_japanInfo"
      ></customize-form-info>
    </el-card>
    <el-card
      shadow="never"
      class="card"
      header="RISK MITIGATION"
      v-if="this.auditStatus !== 5"
    >
      <div v-for="(item1, index) in riskInfo1" :key="index">
        <customize-form-info ref="riskInfoForm" :infoData="a(item1)" />
        <el-divider />
      </div>
      <div v-for="(item2, index) in riskInfo2" :key="index">
        <customize-form-info ref="riskInfoForm" :infoData="a(item2)" />
        <el-divider />
      </div>
    </el-card>
    <el-card shadow="never" class="card" header="FINANCIAL SCORES">
      <customize-form-info
        :infoData="_scoreInfo"
        v-if="this.auditStatus !== 5"
      ></customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="RECENT CREDIT LINE">
      <customize-form-info
        :infoData="_creditLineInfo"
        v-if="this.auditStatus !== 5"
      ></customize-form-info>
    </el-card>
    <el-card shadow="never" header="REQUESTOR COMMENTS" class="card">
      <html-content
        :content="content"
        :token="token"
        v-if="this.auditStatus !== 5"
      />
      <customize-form
        :isShowForm="true"
        :schema="submitFormModel"
        ref="submitterComments"
        v-if="this.auditStatus !== 5"
      >
        <template v-slot:fileListSlot v-if="submitterFileList.length">
          <p
            class="fileItem"
            @click="fileClick(item)"
            v-for="(item, index) in submitterFileList"
            :key="index"
          >
            <i class="el-icon-document"></i>
            {{ item.name }}
          </p>
        </template>
      </customize-form>
    </el-card>
    <el-card class="card" shadow="never" header="CREDIT ANALYST COMMENTS">
      <div v-if="this.auditStatus !== 5">
        <!--  2 3 4禁用，则只是展示    -->
        <html-content
          :content="content1"
          :token="token"
          v-if="
            this.auditStatus === 3 ||
            this.auditStatus === 4 ||
            this.auditStatus === 2
          "
        />
        <quill-editor
          ref="quillEditor"
          :initContent="content1"
          :token="token"
          v-else
        ></quill-editor>
      </div>

      <customize-form
        :isShowForm="true"
        :schema="commentsModel"
        ref="analysisComments"
        :disabled="
          this.auditStatus === 3 ||
          this.auditStatus === 4 ||
          this.auditStatus === 2
        "
        v-if="this.auditStatus !== 5"
      >
        <template
          v-slot:uploadSlot
          v-if="this.auditStatus !== 4 && this.auditStatus !== 3"
        >
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :auto-upload="true"
            :show-file-list="true"
            :on-exceed="handleBeyond"
            :limit="5"
            :on-preview="handlePreview"
            :on-change="handleAnaChange"
            :before-remove="beforeRemove"
            :on-remove="handleRemove"
            :file-list="anaFileList"
            :data="{ type: anaForm.type }"
            :on-success="anaUploadSuccess"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </template>
      </customize-form>
      <div class="up" v-if="this.auditStatus === 4 || this.auditStatus === 3">
        <p
          class="fileItem"
          @click="fileClick(item)"
          v-for="(item, index) in anaFileList"
          :key="index"
        >
          <i class="el-icon-document"></i>
          {{ item.name }}
        </p>
      </div>
    </el-card>
    <el-card shadow="never" class="card" header="REQUEST DETAIL">
      <customize-form-info :infoData="_requestDetailInfo"></customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="DECISIONS">
      <customize-form
        :isShowForm="true"
        ref="decisionForm"
        :schema="decisionFormModel"
        :disabled="this.auditStatus === 3 || this.auditStatus === 4"
        v-if="this.auditStatus !== 5"
      >
        <p style="font-size: 14px; margin-bottom: 20px">Comments:</p>
        <html-content :content="descsionisComments" :token="token" />
        <template
          v-slot:uploadSlot
          v-if="this.auditStatus !== 3 && this.auditStatus !== 4"
        >
          <el-upload
            ref="uploadDecision"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :auto-upload="true"
            :on-preview="handlePreview"
            :limit="5"
            :on-exceed="handleBeyond"
            :show-file-list="true"
            :before-remove="beforeRemove"
            :on-remove="handleDecRemove"
            :on-change="handleDecisionChange"
            :file-list="decisionFileList"
            :on-success="decisionUploadSuccess"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </template>
      </customize-form>
      <div class="up" v-if="this.auditStatus === 3 || this.auditStatus === 4">
        <p
          class="fileItem"
          @click="fileClick(item)"
          v-for="(item, index) in decisionFileList"
          :key="index"
        >
          <i class="el-icon-document"></i>
          {{ item.name }}
        </p>
      </div>
    </el-card>

    <el-card shadow="never" class="addCard" v-if="activeConditions.length">
      <div class="title">ADDITIONAL CONDITIONS</div>
      <el-row
        class="conditionBox"
        v-for="(item, index) in activeConditions"
        :key="index"
      >
        <el-col
          :xs="24"
          :sm="24"
          :md="11"
          :lg="8"
          :xl="8"
          class="_col"
          v-for="(val, key, index) in item"
          :key="`${key}-${index}`"
        >
          {{ transKey(key) }} : {{ val }}
        </el-col>
      </el-row>
    </el-card>

    <!-- 新需求 删除 this.auditStatus === 2 ||-->
    <div
      class="btnArea"
      v-if="this.auditStatus === 1 || this.auditStatus === 6"
    >
      <customize-button
        type="primary"
        @click="() => handleUpdate(false)"
        v-if="isUpdateDecisionBtn"
        :loading="isLoading"
      >
        Update Decision
      </customize-button>
      <customize-button
        type="primary"
        @click="() => handleUpdate(true)"
        v-if="isUpdateBtn"
      >
        Update
      </customize-button>
      <customize-button
        type="primary"
        @click="handleSave"
        class="botBtn"
        v-if="this.isSaveBtn"
      >
        Save
      </customize-button>
      <customize-button @click="showResign = true" v-if="isReassignBtn">
        Reassign
      </customize-button>
    </div>
    <el-dialog title="Reassign" :visible.sync="showResign" width="480px">
      <customize-form
        :isShowForm="true"
        ref="resignForm"
        :schema="resignFormModel"
      >
        <template v-slot:vagueSearch>
          <el-select
            v-model="reassignForm.reassignName"
            filterable
            remote
            reserve-keyword
            placeholder="Search"
            :remote-method="remoteActiveName"
            style="width: 100%"
          >
            <el-option
              v-for="item in optionsActiveName"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </customize-form>
      <div class="btnArea">
        <customize-button @click="showResign = false">Cancel</customize-button>
        <customize-button type="primary" @click="handleResign">
          Reassign
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RProcess from '../../../components/r-process/r-process'
import config from '@/config'
import { ERR_OK } from '@/utils/request'
import { getSelectList } from '@/api'
import {
  getCssDetail,
  getCusInfo,
  finalAuditSave,
  resignAudit,
  getFile,
  cssAudit,
  vagueActiveName,
  getCompletedUpdate,
  getAddlog,
} from './api'
import mixins from '../mixins/mixins'
import htmlContent from 'views/credit-management/credit-audit/html-content'
import quillEditor from 'components/quill-editor/QuillEditor.vue'

export default {
  name: 'credit-audit',
  mixins: [mixins],
  components: {
    RProcess,
    htmlContent,
    quillEditor,
  },
  computed: {
    // 通过计算属性过滤掉additional conditions value为Null的项
    activeConditions: function () {
      return this.additionalConditionsVOList.map(conditionObj => {
        const _temp = {}
        Object.keys(conditionObj).forEach(key => {
          if (conditionObj[key] !== null) {
            _temp['conditionTypeStr'] = conditionObj['conditionTypeStr']
            _temp[key] = conditionObj[key]
            delete _temp.id
            delete _temp.checked
            delete _temp.createTime
            delete _temp.operator
            delete _temp.updateTime
            delete _temp.action
            delete _temp.afterFinancialClosing
            delete _temp.baselineOrUplift
            delete _temp.baselineValidity
            delete _temp.conditionType
            delete _temp.covenantsComplianceCheckFrequency
            delete _temp.expiryDate
            delete _temp.fiscalPeriod
            delete _temp.pnExpiryDate
            delete _temp.status
            delete _temp.tnCType
            delete _temp.type
            delete _temp.validUntill
            // delete _temp.conditionTypeStr
          }
        })
        return _temp
      })
    },
    _basicInfoData() {
      return [
        ...this.basicInfoData,
        ...this.outsideInfo,
        ...this.auditDetail,
        ...this.companyDetailInfo,
      ].map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Valid Amount',
          'Average Overdue Ratio in last 12 mths(%)',
          'Overdue Amount >= 60 Days',
          'Total AR',
          'Total Exposure',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _creditLineInfo() {
      return this.creditLineInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Credit Limit Amount') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _japanInfo() {
      return this.japanInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Latest Financial Year Total Profit',
          'Latest Financial Year Total Revenue',
          'Overdue Amount >= 60 Days',
          'Total Overdue AMT >= 60 Days',
          'Latest Financial Year Total Capital',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _riskInfo() {
      return this.riskInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        return item
      })
    },
    _scoreInfo() {
      return this.scoreInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = ['Theoretical Limit']
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _requestDetailInfo() {
      return this.requestDetailInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Request Amount($)') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
  },
  data() {
    const basicInfoKeys = [
      'code',
      'name',
      'businessStr',
      'regionStr',
      'countryStr',
      'paymentTermReq',
    ]
    const outerKeys = ['totalAR', 'totalBacklog', 'totalExposure']
    const companyDetailKeys = [
      'averageOverdueRatioLast12',
      'overdueAmount60',
      'paytrendOrAverageAging',
    ]
    const japanKeys = [
      'totalOverdueAmt60',
      'tdbRating',
      'latestFYTotalProfit',
      'latestFDate',
      'latestFYTotalRevenue',
      'latestFYTotalCapital',
    ]
    const riskKeys1 = [
      'collateralAmount',
      'collateralCategoryStr',
      'expirationDate',
      'currency',
    ]
    const riskKeys2 = [
      'insuranceAmount',
      'insuranceProviderStr',
      'expirationDate',
      'currency',
    ]
    const scoreKeys = [
      'sp',
      'moodysStr',
      'fitchStr',
      'frisk',
      'zscore',
      'zscoreSecond',
      'scoreCard',
      // 'globalCustomerRating',
      'theoreticalLimit',
    ]
    const submitFormModel = [
      // {
      //   key: 'submitterComment',
      //   label: '',
      //   type: 'textarea',
      //   value: '',
      //   readonly: true,
      //   disabled: true,
      // },
    ]
    const commentsModel = [
      // {
      //   key: 'creditAnalysisComment',
      //   value: '',
      //   type: 'textarea',
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    const creditLineKeys = ['typeStr', 'indateEnd', 'amount', 'requestTypeStr']
    const otherKeys = ['requestTypeStr', 'applyTypeStr']
    const decisionRules = {
      approveType: [
        { required: true, message: 'Can not be empty!', trigger: 'change' },
      ],
      amount: [
        { required: true, message: 'Can not be empty!', trigger: 'blur' },
      ],
      decisionType: [
        { required: true, message: 'Can not be empty!', trigger: 'change' },
      ],
      indateEnd: [
        { required: true, message: 'Can not be empty!', trigger: 'change' },
      ],
    }
    const decisionFormModel = [
      {
        label: 'Credit Request Type',
        type: 'select',
        key: 'requestType',
        disabled: true,
        defaultValue: 1,
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        selectList: [
          {
            id: 1,
            name: 'Line Of Credit',
          },
          {
            id: 2,
            name: 'Other',
          },
        ],
      },
      {
        label: 'Credit Category',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        type: 'select',
        value: '',
        disabled: true,
        selectList: [
          { id: 1, name: 'BAU' },
          { id: 2, name: 'Uplift' },
        ],
        key: 'type',
      },
      {
        style: { display: 'block' },
        label: 'Approved Limit',
        disabled: true,
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        type: 'input',
        key: 'amount',
        input: value => this.handleChange(value),
        value: '',
      },
      {
        style: { display: 'block' },
        label: 'Partial Amount',
        type: 'input',
        key: 'partialAmount',
        disabled: true,
        input: value2 => this.handleValueChange(value2),
        value: '',
      },
      {
        label: 'Decision Type',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        type: 'select',
        value: '',
        key: 'decisionType',
        selectList: [
          { id: 1, name: 'Final Approved' },
          { id: 2, name: 'Declined' },
          { id: 3, name: 'Pending' },
          { id: 5, name: 'Cancelled' },
          { id: 8, name: 'Field Action' },
        ],
      },
      {
        value: '',
        style: { display: 'block' },
        label: 'Expire Date',
        type: 'date',
        disabled: true,
        key: 'indateEnd',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      // {
      //   disabled: true,
      //   key: 'decisionComments',
      //   value: '',
      //   label: 'Comments',
      //   type: 'textarea',
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    const resignFormModel = [
      {
        label: '',
        key: 'activeName',
        type: 'vagueActiveName',
      },
    ]
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      allInfo: {},
      basicInfoKeys,
      isLoading: false,
      basicInfoData: [],
      companydata: [],
      outerKeys,
      outsideInfo: [],
      auditDetail: [], // current credit line 字段
      companyDetailKeys,
      companyDetailInfo: [],
      isJapan: false, // 是否是日本公司
      japanInfo: [],
      japanKeys, // 日本公司数据info
      riskInfo1: [], // risk info & keys
      riskInfo2: [], // risk info & keys
      scoreKeys,
      riskKeys1,
      riskKeys2,
      scoreInfo: [], // score info & keys
      creditLineKeys,
      otherKeys,
      creditLineInfo: [], // credit line info & keys
      requestDetailInfo: [], // request detail info & keys
      submitFormModel,
      commentsModel,
      decisionFormModel,
      processData: [],
      showResign: false,
      resignFormModel,
      anaFileList: [], // ana 上传文件列表
      decisionFileList: [], // decision 上传文件列表
      anaForm: { type: '' },
      decisionRules,
      submitterFileList: [], // submitter 文件列表
      auditStatus: 0,
      // 审核的状态，1-WQ(pending)(3btn)；2-Success(manualapp)(1btn-Update)；3-Reject&4-Cancel(0btn);5-AutoRules(0btn3info+submit&files)
      // decisionTxtArea: '', // decision 的 textarea
      conditionTypeList: [], // addition conditions的下拉列表
      selectedConditions: [],
      conditionRes: [], // addition condition 的form表单数据(所有)
      additionalConditionsVOList: [], // 二次审核的additional conditions 的条件(只显示)
      optionsActiveName: [],
      reassignForm: {
        reassignName: '',
      },
      isReassignBtn: true,
      isResubmitBtn: true,
      isSaveBtn: true,
      isUpdateBtn: true,
      isUpdateDecisionBtn: true,
      content: '',
      token: '',
      content1: '',
      descsionisComments: '',
    }
  },
  mounted() {
    const auditParams = {
      bpmId: this.$route.query.bpmId,
    }
    this._getCssDetail(auditParams)
    this._getAdditionList()
    this.token = this.$storage.getItem('token')
  },
  methods: {
    async handleChange(value) {
      value = this.$utils.setSeperatenum(value)
      this.decisionFormModel = this.decisionFormModel.map(item => {
        if (item.key === 'amount') {
          item.value = value
        }
        return item
      })
    },
    async handleValueChange(value2) {
      value2 = this.$utils.setSeperatenum(value2)
      this.decisionFormModel = this.decisionFormModel.map(item => {
        if (item.key === 'partialAmount') {
          item.value = value2
        }
        return item
      })
    },
    a(item1) {
      return item1.map(item => ({
        key: mixins.methods.transLabelToName(item.key),
        value:
          item.key === 'collateralAmount' || item.key === 'insuranceAmount'
            ? this.$utils.formatAmount(item.value)
            : item.value,
      }))
    },
    async goSnapShot(data) {
      await this.$storage.setItem('customerInfo', {
        name: data.name,
        address: data.address,
        code: data.code,
        country: data.countryStr,
        city: data.city,
        state: data.state,
      })
      let routeUrl = this.$router.resolve({
        path: `/customer-management/${data.id}/info/snapshot`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
      const params = {
        companyId: data.id,
      }
      await getAddlog(params)
    },
    async _getCssDetail(params) {
      try {
        const res = await getCssDetail(params)
        console.log(res)
        // 根据接口返回值动态显示btn area
        this.isReassignBtn = res.isReassignBtn
        this.isResubmitBtn = res.isResubmitBtn
        this.isSaveBtn = res.isSaveBtn
        this.isUpdateBtn = res.isUpdateBtn
        this.isUpdateDecisionBtn = res.isUpdateDecisionBtn
        if (res.creditInfo.requestType === 2) {
          this.decisionFormModel = this.decisionFormModel.map(item => {
            if (item.key === 'amount') {
              item.style.display = 'none'
              delete item.rules
            } else if (item.key === 'partialAmount') {
              item.style.display = 'none'
            }
            return item
          })
          this.decisionFormModel = this.decisionFormModel.map(item => {
            if (item.key === 'type') {
              item = {
                ...item,
                selectList: [
                  { id: 4, name: 'PCR' },
                  { id: 5, name: 'Condition Update' },
                  { id: 6, name: 'Waiver' },
                  { id: 7, name: 'Invoice Extension' },
                ],
              }
            }
            return item
          })
        }
        // TODO final page,不存在decisionType = 4 的情况
        if (res.creditInfo.decisionType === 4) {
          res.creditInfo.decisionType = ''
        }
        // this.commentsModel = [
        //   {
        //     key: 'creditAnalysisComment',
        //     label: '',
        //     type: 'textarea',
        //     value: res.creditInfo.creditAnalystComments,
        //     rules: [
        //       {
        //         min: 0,
        //         max: 20000,
        //         message: 'No more than 20000 characters.',
        //         trigger: 'blur',
        //       },
        //     ],
        //   },
        // ]
        // 获取二次审核的additional conditions (show only)
        this.additionalConditionsVOList = res.additionalConditionsVOList
        res.additionalConditionsVOList.map(item => {
          item.completeAnnualReviewWithinDays === ''
            ? (item.completeAnnualReviewWithinDays = null)
            : item.completeAnnualReviewWithinDays
        })
        // ----- 获取此审核的status，赋值给this.auditStatus
        // 根据status跳转status=1。为pending状态,6为condition approved状态,需要跳转到二次审核
        this.auditStatus = res.creditInfo.status
        // 回显decision的textarea
        // this.decisionTxtArea = res.creditInfo.decisionComments
        // 抽出decisions form需要回显的数据
        const _decisionKeys = Object.keys(res.creditInfo)
        const _decisionFormModel = this.decisionFormModel.map(item => {
          if (_decisionKeys.indexOf(item.key) !== -1) {
            item.value = res.creditInfo[item.key]
            if (item.key === 'decisionComments') {
              if (
                item.value.includes('&gt;') ||
                item.value.includes('&lt;') ||
                item.value.includes('\n')
              ) {
                item.value = item.value.replace(/&lt;/g, '<')
                item.value = item.value.replace(/&gt;/g, '>')
                item.value = item.value.replace(/\n/g, '<br/>')
              }
            }
            item.label === 'Approved Limit' || item.label === 'Partial Amount'
              ? (item.value = this.$utils.formatAmount(
                  res.creditInfo[item.key],
                ))
              : res.creditInfo[item.key]
          }
          return item
        })
        if (
          res.creditInfo.decisionComments.includes('&gt;') ||
          res.creditInfo.decisionComments.includes('&lt;') ||
          res.creditInfo.decisionComments.includes('\n')
        ) {
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/&lt;/g, '<')
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/&gt;/g, '>')
          res.creditInfo.decisionComments =
            res.creditInfo.decisionComments.replace(/\n/g, '<br/>')
        }
        this.descsionisComments = res.creditInfo.decisionComments
        console.log(this.descsionisComments)
        // 在manual approved的时候将两个select置为disabled
        if (this.auditStatus === 2) {
          _decisionFormModel[4].disabled = true
        }
        // 新需求
        if (this.auditStatus === 3 || this.auditStatus === 4) {
          _decisionFormModel[2].style.display = 'none'
          _decisionFormModel[3].style.display = 'none'
          _decisionFormModel[5].style.display = 'none'
        }
        if (
          this.auditStatus === 1 &&
          res.creditInfo.type === 1 &&
          res.running === 2
        ) {
          _decisionFormModel[4].disabled = true
        }
        this.decisionFormModel = _decisionFormModel
        // -----
        // ___ 将ana和decision的文件回显
        this.anaFileList = res.attachments
          .filter(item => item.fileType === 2)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        this.decisionFileList = res.attachments
          .filter(item => item.fileType === 3)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // ---
        // 取出credit line的信息
        const _auditArr = []
        const obj = {}
        obj.key = 'validAmount'
        obj.value = res['validAmount']
        _auditArr.push(obj)
        this.auditDetail = _auditArr
        // 操作credit line 数据
        const _creditLine = []
        Object.keys(res.historyAmount).forEach(key => {
          if (this.creditLineKeys.indexOf(key) !== -1) {
            const obj = {}
            obj.key = key
            obj.value = res.historyAmount[key]
            _creditLine.push(obj)
          }
        })
        this.creditLineInfo = _creditLine
        // ___ 文件列表
        this.submitterFileList = res.attachments
          .filter(item => item.fileType === 1)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // ___
        // take request detail
        const _requestDetailInfo = []
        Object.keys(res.creditInfo).forEach(key => {
          if (res.creditInfo.requestType === 1) {
            if (
              key === 'applyAmount' ||
              key === 'applyTypeStr' ||
              key === 'requestTypeStr'
            ) {
              const _obj = {
                key: key === 'applyAmount' ? 'amountDetail' : key,
                value: res.creditInfo[key],
              }
              _requestDetailInfo.push(_obj)
            }
          } else {
            if (this.otherKeys.indexOf(key) !== -1) {
              const _obj = {}
              _obj.key = key
              _obj.value = res.creditInfo[key]
              _requestDetailInfo.push(_obj)
            }
          }
        })
        this.requestDetailInfo = _requestDetailInfo
        // take process
        this.processData = res.process
        this.processData.map(item => {
          if (item.taskName === 'Manual Approver') {
            item.taskName = 'Final Approver'
          }
        })
        // 回显remark 进行特殊符处理
        if (
          res.creditInfo.remark.includes('&gt;') ||
          res.creditInfo.remark.includes('&lt;') ||
          res.creditInfo.remark.includes('\n')
        ) {
          res.creditInfo.remark = res.creditInfo.remark.replace(/&lt;/g, '<')
          res.creditInfo.remark = res.creditInfo.remark.replace(/&gt;/g, '>')
          res.creditInfo.remark = res.creditInfo.remark.replace(/\n/g, '<br/>')
        }

        // this.submitFormModel = [
        //   {
        //     ...this.submitFormModel[0],
        //     value: res.creditInfo.remark,
        //   },
        // ]
        this.content = res.creditInfo.remark

        // 回显credit analysis comments
        if (
          res.creditInfo.creditAnalystComments.includes('&gt;') ||
          res.creditInfo.creditAnalystComments.includes('&lt;') ||
          res.creditInfo.creditAnalystComments.includes('\n')
        ) {
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&lt;/g, '<')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&gt;/g, '>')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/\n/g, '<br/>')
        }
        this.content1 = res.creditInfo.creditAnalystComments
        // this.commentsModel = [
        //   {
        //     ...this.commentsModel[0],
        //     value: res.creditInfo.creditAnalystComments,
        //   },
        // ]
        // 请求工作流审批客户详情
        this._getCusInfo(res.creditInfo.companyId)
      } catch (err) {
        console.log(err)
      }
    },
    async _getCusInfo(id) {
      try {
        const params = {
          id,
        }
        const res = await getCusInfo(params)
        this.companydata = res.companyInfoVO
        this.allInfo = res
        this.filterData(res)
      } catch (err) {
        console.log(err)
      }
    },
    //对数据进行摘取
    filterData(allData) {
      // 如果是日本
      if (allData.companyInfoVO.countryStr === 'Japan') {
        this.isJapan = true
        if (allData.companyJapanDetailVO) {
          const _japanInfo = []
          this.japanInfo = this.handleKeys(
            allData.companyJapanDetailVO,
            _japanInfo,
            this.japanKeys,
          )
        }
      }
      // 对外层数据进行操作，之后合并一起传给r-form
      const _outArr = []
      Object.keys(allData).forEach(key => {
        if (this.outerKeys.indexOf(key) !== -1) {
          const _obj = {}
          _obj.key = key
          _obj.value = allData[key]
          _outArr.push(_obj)
        }
      })
      this.outsideInfo = _outArr
      // 对 customer basic info操作
      if (allData.companyInfoVO) {
        const _basicInfoData = []
        this.basicInfoData = this.handleKeys(
          allData.companyInfoVO,
          _basicInfoData,
          this.basicInfoKeys,
        )
      }
      // 对company detail 数据进行操作
      if (allData.companyDetailVO) {
        const _companyDetailInfo = []
        this.companyDetailInfo = this.handleKeys(
          allData.companyDetailVO,
          _companyDetailInfo,
          this.companyDetailKeys,
        )
      }
      // 对risk数据进行操作
      if (allData.riskMitigationVO) {
        const InsurancesArr = allData.riskMitigationVO.companyInsurances
        const AssurancesArr = allData.riskMitigationVO.companyAssurances
        for (let item = 0; item < AssurancesArr.length; item++) {
          const _riskInfo1 = []
          this.riskInfo1.push(
            this.handleKeys(AssurancesArr[item], _riskInfo1, this.riskKeys1),
          )
        }
        console.log('this.riskInfo1', this.riskInfo1)
        for (let index = 0; index < InsurancesArr.length; index++) {
          const _riskInfo2 = []
          this.riskInfo2.push(
            this.handleKeys(InsurancesArr[index], _riskInfo2, this.riskKeys2),
          )
        }
      }
      // 对financial scores 进行操作
      if (allData.financialScoresVO) {
        const _scoreInfo = []
        this.scoreInfo = this.handleKeys(
          allData.financialScoresVO,
          _scoreInfo,
          this.scoreKeys,
        )
      }
    },
    // 提出来function handle keys
    handleKeys(dataObj, targetArr, keysArr) {
      Object.keys(dataObj).forEach(key => {
        if (keysArr.indexOf(key) !== -1) {
          const obj = {}
          obj.key = key
          obj.value = dataObj[key]
          targetArr.push(obj)
        }
      })
      return targetArr
    },
    // 底部button事件
    async handleSave() {
      // 处理decision的数据
      const isValid = await this.$refs.decisionForm.validateFields()
      const _loanAmount = {
        ...this.$refs.decisionForm.getFormData(),
      }
      _loanAmount.amount = this.$utils.resetAmount(_loanAmount.amount)
      _loanAmount.partialAmount = this.$utils.resetAmount(
        _loanAmount.partialAmount,
      )
      const Valid = await this.$refs.analysisComments.validateFields()
      console.log(Valid)
      const obj = JSON.parse(JSON.stringify(_loanAmount))
      delete obj.decisionComments
      if (isValid) {
        const params = {
          attachmentAnalystIds: this.anaFileList.length
            ? this.anaFileList.map(file => file.response?.data || file.id)
            : [],
          attachmentDecisionIds: this.decisionFileList.length
            ? this.decisionFileList.map(file => file.response?.data || file.id)
            : [],
          bpmId: this.$route.query.bpmId,
          creditAnalystComments: this.$refs.quillEditor.getContent().trim(),
          decisionComments: _loanAmount.decisionComments,
          creditBpmAdditionalConditionsBOList: [],
          loanAmount: obj,
        }
        try {
          await finalAuditSave(params)
          this.$message.success('success')
        } catch (err) {
          console.log(err)
        }
      }
    },
    async handleUpdate(isCompleted) {
      // 处理decision的数据
      const isValid = await this.$refs.decisionForm.validateFields()
      const _loanAmount = {
        ...this.$refs.decisionForm.getFormData(),
      }
      _loanAmount.amount = this.$utils.resetAmount(_loanAmount.amount)
      _loanAmount.partialAmount = this.$utils.resetAmount(
        _loanAmount.partialAmount,
      )
      const obj = JSON.parse(JSON.stringify(_loanAmount))
      delete obj.decisionComments
      const Valid = await this.$refs.analysisComments.validateFields()
      console.log(Valid)
      // 遍历选择的表单，
      if (isValid) {
        this.isLoading = true
        const params = {
          attachmentAnalystIds: this.anaFileList.length
            ? this.anaFileList.map(file => file.response?.data || file.id)
            : [],
          attachmentDecisionIds: this.decisionFileList.length
            ? this.decisionFileList.map(file => file.response?.data || file.id)
            : [],
          bpmId: this.$route.query.bpmId,
          creditAnalystComments: this.$refs.quillEditor.getContent().trim(),
          decisionComments: _loanAmount.decisionComments,
          loanAmount: obj,
          creditBpmAdditionalConditionsBOList: [],
        }
        try {
          if (isCompleted) {
            await getCompletedUpdate(params)
          } else {
            await cssAudit(params)
          }
          this.timer = setTimeout(() => {
            this.isLoading = false
            this.$message.success('success')
            this.$router.push('/work-queue')
          }, 2000)
        } catch (err) {
          this.isLoading = false
          console.error(err)
        }
      }
    },
    // 派发
    async handleResign() {
      try {
        const params = {
          assignTo: this.reassignForm.reassignName,
          bpmIds: [this.$route.query.bpmId],
        }
        await resignAudit(params)
        this.$message.success('success')
        this.showResign = false
      } catch (err) {
        console.log(err)
      }
    },
    handleAnaChange(file) {
      if (!file.response) {
        const size = file.size / 1024
        if (size < 50000) {
          this.anaFileList.push(file)
        } else {
          this.$message.error('File must not exceed 50M')
          this.anaFileList = [...this.anaFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
        }
      }
    },
    anaUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.anaFileList.pop()
      }
    },
    beforeRemove(file) {
      return this.$confirm(`Confirm delete ${file.name}?`)
    },
    handleRemove(file, fileList) {
      this.anaFileList = fileList
    },
    handleDecRemove(file, fileList) {
      this.decisionFileList = fileList
    },
    handleBeyond() {
      this.$message.warning('No more than 5 attachments!')
    },
    handleDecisionChange(file) {
      if (!file.response) {
        const size = file.size / 1024
        if (size < 50000) {
          this.decisionFileList.push(file)
        } else {
          this.$message.error('File must not exceed 50M')
          this.decisionFileList = [...this.decisionFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
        }
      }
    },
    decisionUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.decisionFileList.pop()
      }
    },
    async handlePreview(fileList) {
      try {
        const params = {
          id: fileList.id,
        }
        await getFile(params)
      } catch (err) {
        console.log(err)
      }
    },
    async fileClick(fileList) {
      try {
        const params = {
          id: fileList.id,
        }
        await getFile(params)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取addition conditions 下拉列表
    async _getAdditionList() {
      try {
        this.conditionTypeList = await getSelectList('ConditionType')
      } catch (err) {
        console.error(err)
      }
    },
    // 模糊查询active name
    async remoteActiveName(query) {
      if (query !== '') {
        try {
          const params = {
            name: query,
          }
          const res = await vagueActiveName(params)
          this.optionsActiveName = res.map(item => ({
            id: item.id,
            label: item.name,
            value: item.username,
          }))
        } catch (err) {
          console.log(err)
        }
      } else {
        this.optionsActiveName = []
      }
    },
    transKey(key) {
      switch (key) {
        case 'action':
          return 'Action Type'
        case 'actionStr':
          return 'Action'
        case 'afterFinancialClosing':
          return 'After financial closing type'
        case 'afterFinancialClosingStr':
          return 'After financial closing'
        case 'amountOr':
          return 'Amount Or %'
        case 'auditedFinancialReportWithinDays':
          return 'Audited financial report within days'
        case 'bankName':
          return 'Bank Name'
        case 'baselineAmount':
          return 'Baseline Amount'
        case 'baselineOrUplift':
          return 'Baseline or Uplift type'
        case 'baselineOrUpliftStr':
          return 'Baseline or Uplift'
        case 'baselineValidity':
          return 'Baseline validity type'
        case 'baselineValidityStr':
          return 'Baseline validity'
        case 'conditionTypeStr':
          return 'Condition Type'
        case 'bpmId':
          return 'BPM ID'
        case 'changeOfOwnershipTo':
          return 'Change of ownership to'
        case 'checked':
          return 'Checked'
        case 'completeAnnualReviewWithinDays':
          return 'Complete annual review within days'
        case 'completeHalfYearReviewDays':
          return 'Complete half year review days'
        case 'completeQuarterlyReviewWithinDays':
          return 'Complete Quarterly review within days'
        case 'conditionType':
          return 'Condition Type'
        case 'consolidatedAuditedFinancialsWithinDays':
          return 'Consolidated audited financials within days'
        case 'consolidatedFinancialsWithinDays':
          return 'Consolidated financials within days'
        case 'covenantsComplianceCertificateWithinDays':
          return 'Covenants compliance certificate within days'
        case 'covenantsComplianceCheckFrequency':
          return 'Covenants compliance check frequency type'
        case 'covenantsComplianceCheckFrequencyStr':
          return 'Covenants compliance check frequency'
        case 'dealerCodesCovered':
          return 'Dealer codes covered'
        case 'expiryDate':
          return 'Expiry date'
        case 'expiryDateStr':
          return 'Expiry date'
        case 'financialCovenantDefinition':
          return 'Financial covenant definition'
        case 'fiscalPeriod':
          return 'Fiscal Period'
        case 'fiscalPeriodStr':
          return 'Fiscal Period'
        case 'gcrRating':
          return 'GCR Rating'
        case 'guarantorName':
          return 'Guarantor name'
        case 'halfYearlyManagementAccountsWithinDays':
          return 'Half yearly management accounts within days'
        case 'id':
          return 'ID'
        case 'insuranceCover':
          return 'Insurance cover %'
        case 'maxNoticePeriodDays':
          return 'Max notice period days'
        case 'maximumPaymentTerms':
          return 'Maximum payment terms'
        case 'notes':
          return 'Notes'
        case 'onCreditHoldIfUndisputedArAgedBeyond':
          return 'On credit hold if undisputed AR aged beyond'
        case 'parentName':
          return 'Parent name'
        case 'personalGuaranteeFrom':
          return 'Personal guarantee from'
        case 'pnExpiryDate':
          return 'PN expiry date'
        case 'pnExpiryDateStr':
          return 'PN expiry date'
        case 'quarterlyManagementAccountsWithinDays':
          return 'Quarterly management accounts within days'
        case 'securedBy':
          return 'Secured by %'
        case 'status':
          return 'Status'
        case 'statusStr':
          return 'Status'
        case 'supergroupName':
          return 'Supergroup Name'
        case 'tnCExpiryDate':
          return 'TnC expiry date'
        case 'tnCType':
          return 'TnC Type'
        case 'tnCTypeStr':
          return 'TnC Type'
        case 'transactionalRating':
          return 'Transactional rating'
        case 'type':
        case 'typeStr':
          return 'Type'
        case 'upliftAmount':
          return 'Uplift amount'
        case 'validUntill':
        case 'validUntillStr':
          return 'Valid untill'
      }
    },
  },
}
</script>

<style scoped lang="less">
.container {
  width: 100%;
  .customerId {
    color: blue;
    font-size: 14px;
    cursor: pointer;
  }
  .card {
    width: 100%;
    margin-bottom: 24px;
  }

  .addCard {
    min-height: 200px;
    ._col {
      margin-bottom: 12px;
      font-size: 14px;
    }
  }

  .fileItem {
    width: 700px;
    height: 30px;
    cursor: pointer;
    font-size: 14px;
  }
  .fileItem:hover {
    color: #409eff;
  }

  .title {
    font-size: 16px;
    color: #3a3f63;
    font-weight: bold;
  }

  .conditionBox {
    width: 100%;
    margin-bottom: 20px;
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    p {
      width: 30%;
      height: 30px;
      line-height: 30px;
    }
  }

  .con-select {
    width: 380px;
    margin-bottom: 20px;
  }

  .label {
    font-size: 14px;
    margin-bottom: 20px;
    margin-top: 40px;
  }

  .processBox {
    width: 100%;
    height: 190px;
    background-color: yellowgreen;
  }
}

.upload {
  width: 100%;
  margin-top: 20px;
  border-radius: 27px;
}

.btnArea {
  width: 100%;
  display: flex;
  margin-top: 24px;

  button {
    margin-right: 24px;
  }

  justify-content: flex-end;
}
</style>
